module.exports = __webpack_public_path__ + "static/media/1_day.e9e50da3.svg";